import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { Button } from "./ui/button";

export const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookie-consent", "accepted");
    setShowBanner(false);
  };

  const declineCookies = () => {
    localStorage.setItem("cookie-consent", "declined");
    setShowBanner(false);
  };

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.3 }}
          data-testid="cookie-banner"
          className="fixed bottom-0 left-0 right-0 z-50 bg-surface border-t border-line p-6"
        >
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex-1">
              <p className="text-text-secondary text-sm">
                Nous utilisons des cookies pour améliorer votre expérience sur notre site. 
                En continuant à naviguer, vous acceptez notre utilisation des cookies 
                conformément à notre politique de confidentialité.
              </p>
            </div>
            <div className="flex items-center gap-4">
              <Button
                variant="ghost"
                onClick={declineCookies}
                data-testid="cookie-decline"
                className="text-text-secondary hover:text-text-primary"
              >
                Refuser
              </Button>
              <Button
                onClick={acceptCookies}
                data-testid="cookie-accept"
                className="bg-navy text-white hover:bg-navy hover:border-gold border border-navy font-semibold rounded-none"
              >
                Accepter
              </Button>
              <button
                onClick={declineCookies}
                data-testid="cookie-close"
                className="text-text-secondary hover:text-text-primary transition-colors"
              >
                <X size={20} />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
